/**
 * Which build this page is running.
 *
 * WHY THIS EXISTS. Two error classes in production were indistinguishable from
 * each other without it, and both cost a day:
 *
 *   - "Failed to execute 'transaction' on 'IDBDatabase': The database connection
 *     is closing" kept arriving after the fix for it shipped. The fix WAS live
 *     (verified by reading the deployed bundle), so those reports came from tabs
 *     still running an older bundle. Nothing in the report said so, so the only
 *     way to tell was to fetch the deployed chunk by hand and grep it.
 *   - "route chunk for X loaded without its export" is BY DEFINITION a mismatch
 *     between the shell a tab loaded and the chunks now on the CDN, so the build
 *     is the single most useful field on the report.
 *
 * A telemetry row that cannot say which code produced it turns every recurrence
 * into an argument. This makes it a lookup.
 *
 * The id is the content hash of the entry chunk, read from the document's own
 * module script tag, which is the freshest statement of which index.html this
 * page loaded. `import.meta.url` is the fallback for anything that changes that
 * markup; "dev" when neither is hashed.
 */
let cached: string | null = null;

const HASH_RE = /\/assets\/index-([A-Za-z0-9_-]+)\.js/;

export function buildId(): string {
  if (cached) return cached;
  let id = "dev";
  try {
    const scripts = document.querySelectorAll<HTMLScriptElement>('script[type="module"][src]');
    for (const s of scripts) {
      const m = HASH_RE.exec(s.getAttribute("src") ?? "");
      if (m?.[1]) {
        id = m[1];
        break;
      }
    }
    if (id === "dev") {
      const m = HASH_RE.exec(import.meta.url);
      if (m?.[1]) id = m[1];
    }
  } catch {
    /* never throw: this is read from an error path */
  }
  cached = id;
  return id;
}
